import React, { useCallback } from 'react'

import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalFooter from 'LuxKit/Modal/ModalFooter'

import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import PriceChangeViewV2 from 'components/Common/PriceChangeView/PriceChangeViewV2'

interface Props {
  oldDisplayPrice: number;
  newDisplayPrice: number;
  oldPropertyFees: number;
  newPropertyFees: number;
}

function BedbankChangePriceModal(props: React.PropsWithChildren<Props>) {
  const {
    oldDisplayPrice,
    newDisplayPrice,
    oldPropertyFees,
    newPropertyFees,
  } = props

  const { resolve } = useModalElementContext<boolean | undefined>()

  const onAcceptNewPrice = useCallback(() => resolve(true), [resolve])

  return (
    <ModalBase size="S">
      <ModalHeader
        title="Price Update"
      />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={24}>
            <BodyText as="p" variant="large">
              The price of your package has changed due to updated availability. Please review the new price and accept it to continue.
            </BodyText>
            <PriceChangeViewV2
              oldPrice={oldDisplayPrice}
              newPrice={newDisplayPrice}
              oldPropertyFees={oldPropertyFees}
              newPropertyFees={newPropertyFees}
            />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Accept updated price',
          onClick: onAcceptNewPrice,
        }}
        secondaryActionProps={{
          children: 'Return to offer',
        }}
      />
    </ModalBase>
  )
}

export default BedbankChangePriceModal
